<script setup lang="ts">
import { computed } from "vue";
import SelectInputWithKeyValue from "@/components/Reusables/Inputs/SelectInputWithKeyValue.vue";
import { GetTransportSourcesQuery } from "@/graphql";

const props = withDefaults(
  defineProps<{
    modelValue: string | null;
    options: GetTransportSourcesQuery["transportSource"];
    /** Inert and greyed out, matching `NumberInput`'s disabled look. Set for a Viewer (RTLCA-5581). */
    disabled?: boolean;
  }>(),
  { disabled: false }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string | null): void;
}>();

const selectOptions = computed(() => (props.options ?? []).map(({ id, label }) => ({ name: label, value: id })));
</script>

<template>
  <SelectInputWithKeyValue
    :value="modelValue"
    :options="selectOptions"
    :is-disabled="disabled"
    placeholder="Select type"
    aria-label="Data source"
    @update:value="emit('update:modelValue', $event)" />
</template>
